import PageHeader from '@/components/common/PageHeader';

const TermsPage = () => {
  return (
    <div data-testid="terms-page">
      <PageHeader 
        title="Terms and Conditions"
        subtitle="Please read these terms carefully before using our services"
        breadcrumbs={[{ label: 'Terms and Conditions' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-gray-600 mb-8">
              <strong>Last Updated: January 1, 2026</strong>
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing or using the services of Zafco Human Resource Management ("Company," "we," "our"), 
              you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, 
              you may not access our services.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">2. Services Description</h2>
            <p className="text-gray-600 mb-6">
              Zafco provides overseas manpower recruitment and immigration consulting services including but not 
              limited to work visa assistance, skilled migration guidance, business visa consultation, and job 
              placement services for various countries.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">3. Client Responsibilities</h2>
            <p className="text-gray-600 mb-4">As a client, you agree to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Submit all required documents in a timely manner</li>
              <li>Inform us of any changes to your circumstances</li>
              <li>Pay all fees as agreed upon</li>
              <li>Not engage in any fraudulent activities</li>
              <li>Cooperate fully with the immigration process</li>
            </ul>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">4. No Guarantee of Results</h2>
            <p className="text-gray-600 mb-6">
              While we strive for the highest success rates, we cannot guarantee the approval of any visa or 
              immigration application. Final decisions rest with the relevant immigration authorities. Our role 
              is to provide expert guidance and assistance to maximize your chances of success.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">5. Fees and Payments</h2>
            <p className="text-gray-600 mb-4">Our fee structure includes:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Consultation and assessment fees</li>
              <li>Professional service fees for application preparation</li>
              <li>Government fees (payable directly to authorities)</li>
              <li>Third-party fees (skills assessment, language tests, etc.)</li>
            </ul>
            <p className="text-gray-600 mb-6">
              All fees are discussed and agreed upon before commencing services. Government and third-party fees 
              are subject to change without notice.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">6. Refund Policy</h2>
            <p className="text-gray-600 mb-6">
              Refund eligibility depends on the service package and stage of processing. Professional service fees 
              for work completed are generally non-refundable. Government and third-party fees are subject to their 
              respective refund policies. Please refer to your service agreement for specific refund terms.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              Zafco shall not be liable for any indirect, incidental, special, or consequential damages resulting 
              from the use of our services, visa refusals, delays in processing, or changes in immigration policies 
              beyond our control.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">8. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              All content on this website, including text, graphics, logos, and software, is the property of 
              Zafco Human Resource Management and is protected by intellectual property laws.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">9. Governing Law</h2>
            <p className="text-gray-600 mb-6">
              These Terms shall be governed by and construed in accordance with the laws of India. Any disputes 
              arising from these Terms shall be subject to the exclusive jurisdiction of the courts in New Delhi.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">10. Contact Information</h2>
            <p className="text-gray-600 mb-6">
              <strong>Zafco Human Resource Management</strong><br />
              Ground Floor 5, Building No. 27B,<br />
              Khizrabad, New Friends Colony,<br />
              New Delhi - 110025<br />
              Phone: +91-9958848998<br />
              Email: info@zafco.in
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
